import { QueryResult, BreadcrumbModel, PageItem } from './N05Breadcrumb.types';

/** Helper function to create the data model for breadcrumbs. */
export function CreateBreadcrumbModel(queryResult?: QueryResult): BreadcrumbModel {
  return {
    ancestors: CreateBreadcrumbAncestors(queryResult),
    currentPage: queryResult?.currentPage,
  };
}

//** A helper function to return the navigationTitle, or fall back to the page item name. */
export function GetBreadcrumbTitle(pageItem?: PageItem): string {
  return pageItem?.navigationTitle?.value || pageItem?.name || '';
}

function CreateBreadcrumbAncestors(queryResult?: QueryResult): Array<PageItem> {
  const breadcrumbs: Array<PageItem> = [];

  // Check if queryResult is provided and currentPage exists
  if (queryResult && queryResult.currentPage) {
    const { currentPage } = queryResult;
    // Loop through ancestors
    if (currentPage.ancestors && currentPage.isSiteRoot?.boolValue === false) {
      for (const ancestor of currentPage.ancestors) {
        // Check if isSiteRoot is true
        if (ancestor.isSiteRoot && ancestor.isSiteRoot.boolValue === true) {
          // Add the ancestor to the list
          breadcrumbs.push(ancestor);
          // Stop reading ancestors
          break;
        }

        // Check if excludeFromBreadcrumb is true
        if (ancestor.excludeFromBreadcrumb && ancestor.excludeFromBreadcrumb.boolValue === true) {
          continue; // Exclude this ancestor from the list
        }

        // Add the ancestor to the list
        breadcrumbs.push(ancestor);
      }
    }
  }

  return breadcrumbs.reverse();
}
